export default __webpack_public_path__ + "static/media/edit_text-icon.f012cf54.svg";